<!-- Start Navbar -->
<nav class="navbar navbar-expand-lg fixed-top custom-nav sticky">
  <div class="container">
    <!-- LOGO -->
    <a class="navbar-brand brand-logo mr-4" routerLink="/index">
      <img src="assets/images/logo.png" class="img-fluid logo-light" alt="" />
      <img
        src="assets/images/dark-logo.png"
        class="img-fluid logo-dark"
        alt=""
      />
    </a>
    <div
      class="navbar-collapse collapse justify-content-center"
      id="navbarCollapse"
    >
      <ul class="navbar-nav navbar-center" id="mySidenav">
        <li
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          class="nav-item"
        >
          <a
            href="javascript:void(0);"
            routerLink="/index"
            class="nav-link"
            i18n
            [innerHTML]="'enliiigne.Home' | translate"
          ></a>
        </li>
        <li class="nav-item" routerLinkActive="active">
          <a
            href="javascript:void(0);"
            routerLink="/contact"
            class="nav-link"
            i18n
            [innerHTML]="'enliiigne.ContactUs' | translate"
          ></a>
        </li>
        <li
          class="nav-item"
          *ngIf="currentLang !== 'en'"
          (click)="useLanguage('en')"
        >
          <a class="nav-link">EN</a>
        </li>
        <li
          class="nav-item"
          *ngIf="currentLang !== 'fr'"
          (click)="useLanguage('fr')"
        >
          <a class="nav-link">FR</a>
        </li>
      </ul>

      <div class="menu-close-btn">
        <i class="mdi mdi-close-circle-outline"></i>
      </div>
    </div>
    <button
      class="navbar-toggler ml-2 p-0"
      type="button"
      data-toggle="collapse"
      data-target="#navbarCollapse"
      aria-controls="navbarCollapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <i class="mdi mdi-menu"></i>
    </button>

    <!-- <div *ngIf="auth.user$ | async; then authenticated else guest"> -->
    <!-- template will replace this div -->
    <!-- </div> -->
    <!-- 
    <ng-template #guest>

      <div class="header_btn" >
        <a href="javascript:void(0);" routerLink="/workspace" (click)="auth.googleSignin()" class="btn btn-sm white-btn" i18n >LogIn<i class="mdi mdi-arrow-right ml-2"></i></a>
        <button class="navbar-toggler ml-2 p-0" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <i class="mdi mdi-menu"></i>
        </button>
      </div>
      </ng-template>
      <ng-template #authenticated>

      <div class="header_btn" >
        <a href="javascript:void(0);"  routerLink="/home" (click)="auth.signOut()" class="btn btn-sm white-btn" i18n>Logout <i class="mdi mdi-arrow-right ml-2"></i></a>
        <button class="navbar-toggler ml-2 p-0" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
          <i class="mdi mdi-menu"></i>
        </button>
      </div>
      </ng-template> -->
  </div>
</nav>
<!-- End Navbar -->
